import { render, staticRenderFns } from "./Tops.vue?vue&type=template&id=653068c5&scoped=true&"
import script from "./Tops.vue?vue&type=script&lang=js&"
export * from "./Tops.vue?vue&type=script&lang=js&"
import style0 from "./Tops.vue?vue&type=style&index=0&id=653068c5&prod&lang=scss&"
import style1 from "./Tops.vue?vue&type=style&index=1&id=653068c5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653068c5",
  null
  
)

export default component.exports